import { setDependency } from 'shared-lib/dependencies';

import store from '@/store';
import router from '@/router';
import config from '@/config';
import * as locale from '@/locale';
import apiClient from '@/api/client';

// set shared-lib dependencies
setDependency('store', store);
setDependency('router', router);
setDependency('config', config);
setDependency('locale', locale);
setDependency('apiClient', apiClient);
